import { useIntl } from 'react-intl';
import { useCallback } from 'react';

import { formatDecimal } from './formatDecimal';

export const useFormatDollars = () => {
  const intl = useIntl();
  return useCallback(
    (dollars: number, options?: { displayCentsWhenLessThanDollar?: boolean }): string => {
      if (options?.displayCentsWhenLessThanDollar && dollars < 1) {
        return `${dollars * 100}¢`;
      }

      const maximumFractionDigits = 2;
      const formattedPrice = formatDecimal(dollars, maximumFractionDigits);

      return intl.formatNumber(formattedPrice, {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits,
      });
    },
    [intl],
  );
};

export const convertCentsToDollars = (cents: number) => cents / 100;
